export const CLIENT_RETRY_COUNT = 3;

export const ERR_BEARER_TOKEN_NOT_SET = 'Bearer token not set';
export const ERR_FETCH_ERROR = 'Fetch error:';
export const ERR_LOGIN_REQ = 'Login required';
